import { AnimatePresence, motion } from 'framer-motion';
import { defineMessages, useIntl } from 'react-intl';

import searchDoc from '../../assets/icons/searchDoc.svg';

const searchTermMessages = defineMessages({
  searchTermCTA: {
    defaultMessage: 'Search for "{searchTerm}" on the web',
    id: 'evv8Cq',
  },
});

export function SearchTermCTA({
  searchTerm,
  onSearchTermClick,
}: {
  searchTerm: string;
  onSearchTermClick: () => void;
}) {
  const { formatMessage } = useIntl();

  return (
    <AnimatePresence>
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="mb-2 flex w-full items-center break-all rounded-lg bg-gray-2 p-4 text-start text-base hover:bg-gray-3 focus:bg-gray-3"
        onClick={onSearchTermClick}
      >
        <img src={searchDoc} className="mr-3 h-5 w-5" alt="" />
        {formatMessage(searchTermMessages.searchTermCTA, {
          searchTerm,
        })}
      </motion.button>
    </AnimatePresence>
  );
}
